module.exports = __webpack_public_path__ + "img/hzfp45.d5a6bfab.png";